import { domainStore } from './store/domains.store';
import { istatStore } from './store/istat.store';
import { ISyncOptions } from '@/utils/ISyncOptions';

export default {

  startup: async (): Promise<void> => {
    await domainStore.getters.composizioneVegetazionali();
    await domainStore.getters.danniOsservati();
    await domainStore.getters.esposizioni();
    await domainStore.getters.feriteTroncoCicatrizzazione();
    await domainStore.getters.feriteTroncoDimensioni();
    await domainStore.getters.fustiFibratura();
    await domainStore.getters.fustiNodosita();
    await domainStore.getters.fustiSezione();
    await domainStore.getters.fustiTipo();
    await domainStore.getters.giaciture();
    await domainStore.getters.governi();
    await domainStore.getters.lettiere();
    await domainStore.getters.origineMaterialiSelezionati();
    await domainStore.getters.originePiantePlus();
    await domainStore.getters.originePopolamentiForestali();
    await domainStore.getters.pietrosita();
    await domainStore.getters.posizioniPiantePlus();
    await domainStore.getters.potaturePiantePlus();
    await domainStore.getters.specieArboree();
    await domainStore.getters.struttureOrizzontali();
    await domainStore.getters.struttureVerticali();
    await domainStore.getters.substratiPetrogenici();
    await domainStore.getters.terreniSottostanti();
    await domainStore.getters.tipiPiantePlus();
    await domainStore.getters.trattamenti();
    await domainStore.getters.ubicazioni();

    await istatStore.getters.istat();
  }

} as ISyncOptions;